/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface LumpComponent
 */
export interface LumpComponent {
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  model: string;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  modelTypeUuid: string;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  nameRu?: string | null;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  formula?: string | null;
  /**
   *
   * @type {string}
   * @memberof LumpComponent
   */
  uNIFACStructure?: string | null;
}

/**
 * Check if a given object implements the LumpComponent interface.
 */
export function instanceOfLumpComponent(value: object): value is LumpComponent {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('model' in value) || value['model'] === undefined) return false;
  if (!('modelTypeUuid' in value) || value['modelTypeUuid'] === undefined) return false;
  return true;
}

export function LumpComponentFromJSON(json: any): LumpComponent {
  return LumpComponentFromJSONTyped(json, false);
}

export function LumpComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LumpComponent {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    model: json['model'],
    modelTypeUuid: json['model_type_uuid'],
    nameRu: json['name_ru'] == null ? undefined : json['name_ru'],
    formula: json['Formula'] == null ? undefined : json['Formula'],
    uNIFACStructure: json['UNIFACStructure'] == null ? undefined : json['UNIFACStructure']
  };
}

export function LumpComponentToJSON(value?: LumpComponent | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    model: value['model'],
    model_type_uuid: value['modelTypeUuid'],
    name_ru: value['nameRu'],
    Formula: value['formula'],
    UNIFACStructure: value['uNIFACStructure']
  };
}
